import { MdDoNotDisturb } from "react-icons/md";
type DisplayNullProps = {
  size?: number;
};
export const DisplayNull = ({ size }: DisplayNullProps) => (
  <MdDoNotDisturb size={size} />
);
